module.exports = __webpack_public_path__ + "img/SketchPng1741575389850ebf40aaa5803de22d54f8799d411adb000e9c1064b48cac741e.1097ca61.png";